<template>
  <div class="authority-manage rhBrand-box position-header">
    <navHeader :titleList="['系统管理', '品类管理']" />
    <div class="rhBrand-content common-padding">
      <el-card class="box-card flex-1 table-card">
        <el-row>
          <el-col :span="12">
            <el-button
              class="btns-add"
              icon="el-icon-plus"
              size="small"
              @click="add"
              >添加</el-button
            >
          </el-col>
        </el-row>
        <el-row class="common-margin flex-1 table-main">
          <el-table
            :data="tableData"
            border
            style="width: 100%"
            row-key="id"
            class="flex-1" stripe height="100%"
             :tree-props="{children: 'childList', hasChildren: 'hasChildren'}"
          >
              <!-- <template slot-scope="scope">
                <el-radio :label="scope.row.id" v-model="scope.row">&nbsp</el-radio>
              </template> -->
            <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
            <el-table-column prop="name" align="center" show-overflow-tooltip label="名称">
            </el-table-column>
            <el-table-column prop="level" align="center" label="层级">
            </el-table-column>
            <el-table-column prop="parentId" align="center" show-overflow-tooltip label="父编号">
            </el-table-column>
            <!-- <el-table-column prop="remark" align="center" show-overflow-tooltip label="备注">
            </el-table-column> -->
            <el-table-column align="center" label="操作" width="120">
              <template slot-scope="scope">
                <div class="btn-box">
                  <el-button
                    icon="el-icon-edit"
                    type="text"
                    @click="edit(scope.row.id)"
                    size="small"
                    >编辑</el-button
                  >
                  <!-- <el-button
                    icon="el-icon-document-checked"
                    type="primary"
                    @click="verify(scope.row.id, scope.row.status, scope.row.statusRemarks)"
                    size="small"
                    >新增</el-button
                  > -->
                  <el-button
                    icon="el-icon-delete"
                    type="text"
                    @click="deleteInfo(scope.row.id)"
                    size="small"
                    >删除</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <!-- <el-pagination
              @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next"
            :total="total"
          >
          </el-pagination> -->
        </el-row>
      </el-card>
    </div>
    <el-dialog
        :title="title + '品类'"
        width="30%"
        class="system-dialog"
        :visible.sync="dialogShow"
        :close-on-click-modal="false"
        :show-close="false"
        @close="cancel"
    >
      <el-form :model="form" :rules="rules" ref="addForm" label-width="100px">
        <el-form-item label="名称：" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="层级：" prop="level">
          <el-input v-model="form.level"></el-input>
        </el-form-item>
        <el-form-item label="类型：" prop="type">
          <el-select filterable  v-model="form.type" placeholder="请选择" style="width: 100%">
            <el-option
              v-for="item in typeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="父级Id：" prop="parentName">
          <el-input v-model="form.parentName" @click.native="selectParent"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>

    <!--选择上级菜单-->
    <el-dialog title="上级菜单" :visible.sync="parentDialogVisible" width="25%"  :close-on-click-modal="false">
      <tree :nodes="nodes" :setting="parentSetting" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelNode">取 消</el-button>
        <el-button type="primary" @click="parentDialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import navHeader from '../../components/navHeader.vue'
import tree from 'vue-giant-tree'

export default {
  data () {
    return {
      id: '',
      name: '',
      type: '',
      title: '添加',
      selectData: [],
      tableData: [],
      dialogShow: false,
      parentDialogVisible: false,
      nodes: [],
      // 上级部门树配置
      parentSetting: {
        view: {
          showLine: true,
          showIcon: false,
          fontCss: { 'font-size': '12px', color: '#333' }
        },
        // 设置这里会显示复选框
        // check: {
        //   enable: true
        // },
        data: {
          simpleData: {
            enable: true,
            idKey: 'id',
            pIdKey: 'parentId',
            rootPId: '0'
          }
        },
        callback: {
          onClick: this.ztreeParentOnClick
        }
      },
      form: {},
      rules: {
        name: { required: true, message: '请输入名称', trigger: 'blur' },
        level: { required: true, message: '请填写层级', trigger: 'blur' },
        type: { required: true, message: '请选择类型', trigger: 'blur' },
        parentName: { required: true, message: '请选择父级', trigger: 'blur' }
      },
      typeList: [
        {
          label: '日化品类',
          value: '1'
        },
        {
          label: '专业品类',
          value: '2'
        },
        {
          label: '工厂品类',
          value: '3'
        },
        {
          label: '服务商品类',
          value: '4'
        }
      ],
      currentPage: 1,
      pageSize: 10,
      total: 1
    }
  },
  components: {
    navHeader,
    tree
  },
  created () {
    this.getPageList()
    this.getAllList()
  },
  mounted () {},
  methods: {
    async getPageList () {
      let params = {
        name: this.name,
        type: this.type
      }
      let { data: res } = await this.$http.post('brandCategory/getAllList', params)
      if (res.code === '200') {
        this.tableData = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    async getAllList () {
      let { data: res } = await this.$http.get('brandCategory/getFlatList')
      if (res.code === '200') {
        this.nodes = res.data
      }
    },
    reset () {
      this.name = ''
      this.type = ''
      this.getPageList()
    },
    add () {
      this.title = '添加'
      this.dialogShow = true
    },
    edit (id) {
      this.title = '编辑'
      this.dialogShow = true
      this.$http.post('/brandCategory/getById', { id }).then(res => {
        if (res.data.code === '200') {
          this.form = res.data.data
          this.form.parentId = res.data.data.parentId
          console.log(this.form)
        }
      })
    },
    confirm () {
      this.$refs.addForm.validate(val => {
        if (val) {
          let params = JSON.parse(JSON.stringify(this.form))
          let url = ''
          if (this.title === '添加') {
            url = '/brandCategory/add'
          } else {
            url = '/brandCategory/update'
          }
          this.$http.post(url, params).then(res => {
            if (res.data.code === '200') {
              this.dialogShow = false
              this.getPageList()
              this.$message.success(res.data.msg)
              this.addForm = {
                name: '',
                type: '',
                parentId: '',
                parentName: '',
                level: ''
              }
            }
          })
        }
      })
    },
    cancel () {
      this.dialogShow = false
      this.form = {
        name: '',
        type: '',
        parentId: '',
        parentName: '',
        level: ''
      }
    },
    deleteInfo (id) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        showClose: false
      }).then(() => {
        this.$http.post('/brandCategory/delete', {id}).then(res => {
          if (res.data.code === '200') {
            this.$message.success(res.data.msg)
            this.getPageList()
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(() => {
          this.$message({
            type: 'error',
            message: '删除失败'
          })
        })
      })
    },
    // 上级部门树点击事件
    ztreeParentOnClick (evt, treeId, treeNode) {
      this.form.parentName = treeNode.name
      this.form.parentId = treeNode.id
    },
    cancelNode () {
      this.form.parentName = ''
      this.form.parentId = ''
      this.parentDialogVisible = false
    },
    // 选择上级菜单
    selectParent () {
      this.parentDialogVisible = true
    }
  }
}
</script>

<style lang="less"></style>



// WEBPACK FOOTER //
// src/pages/systemManagement/category.vue